import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f923204a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "sec_banner hiddenSlides"
};
const _hoisted_2 = ["src"];
export default {
  setup(__props) {
    const $http = inject('$http');
    const bannerList = ref([]);

    const getBannerList = async () => {
      const res = await $http.getBannerList();
      bannerList.value = res || [];
    };

    getBannerList();
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");

      const _component_el_carousel = _resolveComponent("el-carousel");

      return bannerList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
        arrow: "never",
        height: "990px"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerList.value, item => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: item.id
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              class: "banner-img",
              src: item.file_url
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })])) : _createCommentVNode("", true);
    };
  }

};